import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import {
  BuildOutlined,
  DollarOutlined,
  ShoppingOutlined,
  CaretRightOutlined,
} from '@ant-design/icons';
import './style.scss';
/**
 *
 */
const ReportList = ({ user }) => {
  useEffect(() => {
  }, []);
  const reportList = [
    {
      title: 'Inventory',
      icon: <ShoppingOutlined />,
      subList: [
        { title: 'Stock Summary', link: 'inventory_summary' },
        { title: 'Stock Register', link: 'inventory_report' },
        { title: 'Stock Transfer Register', link: 'stock_transfer_report' },
        { title: 'Stock Adjustment Register', link: 'inventory_adjustment' },
        { title: 'Stock Inwards Register ', link: 'stock_inward_report' },
        { title: 'Stock Outwards Register', link: 'stock_outward_report' },
        { title: 'Stock Ageing Report', link: 'stock_ageing_report' },
      ],
      visible: user?.tenant_info?.inventory_config?.sub_modules?.product?.is_active,
    },
    {
      title: 'Purchase',
      icon: <DollarOutlined />,
      subList: [
        { title: 'Purchase Register', link: 'purchase_ledger' },
        { title: 'Purchase By Vendor', link: 'purchase_by_vendor' },
        { title: 'Purchase By Products', link: 'purchase_by_product' },
      ],
      visible: user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.is_active,
    },
    {
      title: 'Sales',
      icon: <DollarOutlined />,
      subList: [
        { title: 'Sales Register', link: 'sales_ledger' },
        { title: 'Sales By Customer', link: 'sales_by_customer' },
        { title: 'Sales By Products', link: 'sales_by_product' },
      ],
      visible: user?.tenant_info?.sales_config?.sub_modules?.sales_order?.is_active,
    },
    {
      title: 'Production',
      icon: <BuildOutlined />,
      subList: [
        { title: 'FG Production Report', link: 'fg_report' },
        { title: 'RM Production Report', link: 'rm_report' },
      ],
      visible: user?.tenant_info?.production_config?.sub_modules?.bill_of_material?.is_active,
    },
  ];

  return (
    <div className="report-list__wrapper">
      <div className="ant-row">
        {reportList?.filter((item) => item?.visible)?.map((item) => (
          <div key={item.title} className="ant-col-md-8">
            <div className="report-list__row-head">
              <div className="report-list__row-icon">
                {item.icon}
              </div>
              <div className="report-list__row-heading">
                {item.title}
              </div>
            </div>
            <div className="report-list__row-body">
              {item?.subList?.map((subItem) => (
                <div className="report-list__row-item" key={subItem}>
                  <CaretRightOutlined />
                  <Link to={`reports/${subItem.link}`}>
                    <div className="report-list__row-item-heading">
                      {subItem.title}
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = ({ /* Import Reducers here */ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (/* Import actions here */ dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportList));
